import React, { PropTypes } from 'react';

import { NitroContentNotAvailable, NitroLoading } from 'nitro-components';

import DataProvider from '../dataProvider';
import { TabsArray } from '../../../../components/factoryComponents';

/**
 * This component displays tabs of bookmark data.
 *
 * The bookmarks are loaded when the component is mounted either from an api call or the store depending on the state of
 * {@link common.refreshBookmarks}
 */
class Bookmarks extends React.Component {
  componentDidMount() {
    // if refresh bookmarks set then only call fetchbookmarks and refresh store
    // else return it from store
    if (this.props.common.refreshBookmarks) {
      this.props.actions.fetchBookmarks();
    }
  }

  render() {
    const { bookMarksData, fetchingBookmarks } = this.props;
    if (this.props.fetchingBookmarks) {
      return <NitroLoading />;
    }

    if ((this.props.dataError || !bookMarksData.length) && !fetchingBookmarks) {
      return <NitroContentNotAvailable />;
    }

    return (
      <TabsArray
        key="contents"
        data={bookMarksData}
        onRowClick={this.props.onRowClick}
      />
    );
  }
}

Bookmarks.propTypes = {
  onRowClick: PropTypes.func,
  fetchingBookmarks: PropTypes.bool,
  common: PropTypes.object,
  bookMarksData: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.any
  ])
};

Bookmarks.defaultProps = {
  onRowClick: () => {}
};

export default DataProvider(Bookmarks);



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/components/Bookmarks.js